import { IStatusPanelParams } from 'ag-grid-community';
import React, { FC, useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'hooks/use-translation';
import { BodyShort01 } from 'ozone/atoms';
import { Content, Empty, Loaded, Loading } from 'stores/core';

const TasksStatus = styled(BodyShort01).attrs({
  'data-cy': 'task-grid.status-panel.tasks',
})`
  color: var(--grid-header-color, --gray-90);
`;

interface StatusPanelExtraParams {
  isPaginated?: boolean;
  loading?: boolean;
}

export const Tasks: FC<IStatusPanelParams & StatusPanelExtraParams> = ({
  api,
  isPaginated,
}) => {
  const loading = useTranslation('task_list.status_panel.count.loading');
  const [count, setCount] = useState<Content<number>>(Empty());
  const status = useTranslation('task_list.status_panel.count', {
    count: count[1] ?? 0,
  });
  const listener = useCallback(() => {
    setCount(Loading());
    let rowCount = 0;

    if (isPaginated) {
      rowCount = api.getDisplayedRowCount();
    } else {
      api?.forEachNodeAfterFilter?.((node) => {
        if (node.id !== 'provisional') {
          rowCount += 1;
        }
      });
    }
    if (rowCount === 1) {
      // grid doesn't trigger render if loading params is getting changed. So failing back to each node to check actually do we have any node
      let actualRow = 0;

      api.forEachNode((node) => {
        if (node.id) {
          actualRow += 1;
        }
      });
      if (actualRow === 0) {
        setCount(Loading());

        return;
      }
    }

    setCount(Loaded(rowCount));
  }, [isPaginated, api]);

  useEffect(() => {
    api.addEventListener('modelUpdated', listener);

    return () => api.removeEventListener('modelUpdated', listener);
  }, [api, listener]);

  return <TasksStatus>{count[0] !== 'loaded' ? loading : status}</TasksStatus>;
};
